import { CSSProperties, useCallback, useEffect, useRef, useState } from "react"
import { Portal } from 'react-portal';
import { useWindowSize } from "../hooks/useWindowSize";
import { MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle } from "mdb-react-ui-kit";

const MODAL_ZINDEX = 1055;

export interface CustomModalProps {
    children: React.ReactNode;
    onClose?: () => void;
    onCloseFinished?: () => void;
    open?: boolean;
    title?: string;
    header?: React.ReactNode;
    footer?: React.ReactNode;
    dialogClassname?: string;
    bodyClassName?: string;
    bodyStyle?: CSSProperties;
    dialogStyle?: CSSProperties;
    staticBackdrop?: boolean;
}

export const CustomModal = ({children, open, title, header, footer, dialogClassname, dialogStyle, bodyClassName, bodyStyle, staticBackdrop, onClose, onCloseFinished}: CustomModalProps) => {
    const onModalClose = useCallback(() => {
        if (onClose) onClose();
        setTimeout(() => {
            if (onCloseFinished) onCloseFinished();
        }, 350);
    }, [onClose, onCloseFinished])

    return (
        <MDBModal open={open} onClose={onModalClose} tabIndex='-1' staticBackdrop={staticBackdrop}>
            <MDBModalDialog centered className={dialogClassname} style={dialogStyle}>
                <MDBModalContent>
                    { (title || header) && <MDBModalHeader>
                        <MDBModalTitle>{title}</MDBModalTitle>
                        {header}
                        <MDBBtn className='btn-close' color='none' onClick={onClose}></MDBBtn>
                    </MDBModalHeader> }
                    
                    <MDBModalBody className={bodyClassName} style={bodyStyle}>
                        {children}
                    </MDBModalBody>

                    { footer &&
                        <MDBModalFooter>
                            { footer }
                        </MDBModalFooter>
                    }
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    );
}

export const modalZIndex = MODAL_ZINDEX;